import { render, staticRenderFns } from "./etapa_1.vue?vue&type=template&id=7064bc3e&scoped=true&"
import script from "./etapa_1.vue?vue&type=script&lang=js&"
export * from "./etapa_1.vue?vue&type=script&lang=js&"
import style0 from "./etapa_1.vue?vue&type=style&index=0&id=7064bc3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7064bc3e",
  null
  
)

export default component.exports